import { useState } from 'react';
import { Grid, IconButton, ListItemButton, Typography } from '@mui/material';

import TextField from 'Lib/components/form/TextField';
import FormDialog from 'Lib/muiComponents/dialog/FormDialog';

export default function TableRowEdit({ data, button, columns, onSubmit, setAnchorElement }) {
    const [open, setOpen] = useState(false);

    const toggleModal = () => {
        if (open && setAnchorElement) setAnchorElement(null);
        setOpen(prevState => !prevState);
    };

    return (
        <>
            {button ? (
                <IconButton onClick={toggleModal}>edit</IconButton>
            ) : (
                <ListItemButton onClick={toggleModal}>
                    <Typography>Edit</Typography>
                </ListItemButton>
            )}
            <FormDialog initialValues={data} open={open} onSubmit={onSubmit} toggle={toggleModal}>
                {() => (
                    <Grid container spacing={4}>
                        {columns.map((column, index) => (
                            <Grid item key={index}>
                                {column.fieldName && <TextField id={column.fieldName} name={column.fieldName} label={column.label} />}
                            </Grid>
                        ))}
                    </Grid>
                )}
            </FormDialog>
        </>
    );
}
